module.exports = __webpack_public_path__ + "img/WILD.a7d1c069.svg";